module.exports = __webpack_public_path__ + "static/media/logosmall.497ae01f.png";